/* eslint-disable no-useless-catch */

import { entityService } from './services';
// #endregion Local Imports

const pathname = '/user-custom-domains';

export const UserCustomDomainAPI = {
  create: async (body: CreateUserCustomDomainBody) => {
    try {
      const response = await entityService.post(pathname, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  findCustomDomainWithEntity: async () => {
    const url = `${pathname}/entity`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface CreateUserCustomDomainBody {
  domain: string;
  ip?: string;
  appType: number;
  logoName: any[];
  avatar: any;
  banner?: any;
  theme: any;
  seo: any;
  displayName: string;
}
